import {
  axiosSysApi
} from '../../axios_init'

const state = {
  pre_day: '9月14日',
  map_option: {
    center: [102.73, 25.04],
    zoom: 11
  },
  active_station: '',
  oil_location: {},
  station_location: {},
  station_location_list: [],
  // 0: start 10:数据导入完成 20:预测完成 30: 订单分配完成
  pre_status: 0,
  pre_data: [],
  pre_source_data: [],
  pre_car_data: [],
  pre_car_data2: [],
  pre_day_data: [],
  pre_show_3: [],
  oil_stations: [],
  oil_station: null,
  oil_source_station: null,
  oil_source_stations: [],
  cars_info: [],
  xz_data: [],
  dx_data: [],
  error_pre_data: []
}

const getters = {
  errorPreData: state => state.error_pre_data,
  xzData: state => state.xz_data,
  dxData: state => state.dx_data,
  preDay: state => state.pre_day,
  activeStation: state => state.active_station,
  mapOption: state => state.map_option,
  oilLocation: state => state.oil_location,
  stationLocation: state => state.station_location,
  stationLocationList: state => state.station_location_list,
  carsInfo: state => state.cars_info,
  preStatus: state => state.pre_status,
  preData: state => state.pre_data,
  PreSourceData: state => state.pre_source_data,
  preCarData: state => state.pre_car_data,
  preCarData2: state => state.pre_car_data2,
  preDayData: state => state.pre_day_data,
  preShow1: state => state.pre_show_1,
  oilSourceStation: state => state.oil_source_station,
  oilSourceStations: state => state.oil_source_stations,
  oilStations: state => state.oil_stations,
  oilStation: state => state.oil_station
}

const actions = {
  updateCheckData ({ commit }) {
    commit('updateCheckData')
  },
  setErrorPreData ({ commit }, data) {
    commit('changeErrorPreData', data)
  },
  editPreSourceData ({ commit }, data) {
    commit('editOnePreSourceData', data)
  },
  setActiveStation ({ commit, dispatch, getters }, data) {
    commit('changeActiveStation', data)
    let mapOption = getters.stationLocation[data]
    if (data && mapOption) {
      dispatch('setMapPreCenter', {center: mapOption, zoom: 12})
    }
    dispatch('selectMapOneRoute', data)
    dispatch('selectMapOil', data)
    dispatch('selectMapStation', data)
  },
  setOilLocation ({ commit, dispatch }, data) {
    commit('changeOilLocation', data)
  },
  setStationLocation ({ commit, dispatch }, data) {
    let newData = []
    for (let key in data) {
      newData.push({
        name: key,
        value: data[key]
      })
    }
    dispatch('setAllMapStation', newData)
    commit('changeStationLocation', data)
  },
  setCarsInfo ({ commit }, data) {
    commit('changeCarsInfo', data)
  },
  editOnePre ({ commit }, data) {
    commit('editOnePre', data)
  },
  setOilStation ({ commit }, data) {
    commit('changeOilStation', data)
  },
  setOilSourceStation ({ commit }, data) {
    commit('changeOilSourceStation', data)
  },
  setPreShow3 ({ commit }, data) {
    commit('changePreShow3', data)
  },
  setPreData ({ commit, getters, dispatch }, data) {
    let newData = []
    data.forEach(function (item) {
      let showData = []
      if (getters.oilLocation && getters.oilLocation[item.oil]) {
        newData.push({
          name: item.oil,
          value: [...getters.oilLocation[item.oil], showData]
        })
      }
    })
    dispatch('setAllMapOil', newData)
    commit('changePreData', data)
  },
  setPreSourceData ({ commit }, data) {
    commit('changePreSourceData', data)
  },
  setPreCarData ({ commit, getters, dispatch }, data) {
    let newData = []
    let day = getters.preDay
    let newData2 = []
    data.forEach(function (item) {
      let oilName = item[0]
      let itemDay = item[1]
      if (itemDay === day) {
        newData2.push(item)
        let stationName = getters.oilLocation[oilName] ? getters.oilLocation[oilName][2] : ''
        if (stationName !== '' && stationName !== '') {
          let oilLocation = getters.oilLocation[oilName] ? [getters.oilLocation[oilName][0], getters.oilLocation[oilName][1]] : []
          let stationLocation = getters.stationLocation[getters.oilLocation[oilName][2]] ? [...getters.stationLocation[getters.oilLocation[oilName][2]]] : []
          if (oilLocation.length > 0 && stationLocation.length > 0) {
            newData.push({
              name: item[6],
              data: [{
                fromName: stationName,
                toName: oilName,
                coords: [stationLocation, oilLocation],
                info: item
              }]
            })
          } else {
            console.log(stationName)
          }
        }
      }
    })
    dispatch('setAllMapOneRoute', newData)
    commit('changePreCarData', newData2)
  },
  setPreDayData ({ commit }, data) {
    commit('changePreDayData', data)
  },
  setOilStations ({ commit, getters, dispatch }, data) {
    commit('changeOilStations', data)
    if (getters.oilStation === null && data.length) {
      dispatch('setOilStation', data[0])
    }
  },
  setOilSourceStations ({ commit, getters, dispatch }, data) {
    commit('changeOilSourceStations', data)
    if (getters.oilSourceStation === null && data.length) {
      dispatch('setOilSourceStation', data[0])
    }
  },
  delPreData ({ commit, dispatch }, data) {
    let pData = data['进销存和预测结果数据']
    let dData = data['每日订单']
    let xzData = data['闲置油罐加油站']
    let dxData = data['小罐多销加油站']

    let delPData = []
    let delDData = []
    let oilStations = []
    for (let key in pData) {
      oilStations.push(key)
      let oneOil = {'oil': key, data: pData[key]}
      delPData.push(oneOil)
    }
    for (let key in dData) {
      dData[key].forEach(function (item) {
        delDData.push(item)
      })
    }
    dispatch('setOilStations', oilStations)
    dispatch('setPreData', delPData)
    commit('changeXzData', xzData)
    commit('changeDxData', dxData)
    dispatch('setPreDayData', delDData)
    dispatch('setLoadingText', '分析预测完成')
    dispatch('setPercentage', {'start': 100, 'next': 100})
  },
  delPreSourceData ({ commit, dispatch }, data) {
    let pData = data
    let delPData = []
    let oilStations = []
    for (let key in pData) {
      let newPData = pData[key].sort(function (a, b) {
        return a[0].split('号')[0] - b[0].split('号')[0]
      })
      oilStations.push(key)
      let oneOil = {'oil': key, data: []}
      newPData.forEach(function (item) {
        oneOil.data.push([key, ...item])
      })
      delPData.push(oneOil)
    }
    dispatch('setOilSourceStations', oilStations)
    dispatch('setPreSourceData', delPData)
  },
  loadLocationData ({ commit, getters, dispatch }, data) {
    axiosSysApi.get('/static/location.json').then(function (response) {
      dispatch('setOilLocation', response.data['加油站位置'])
      dispatch('setStationLocation', response.data['油库位置'])
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '分析预测异常',
        message: '错误信息:' + e
      })
      console.log(e)
    })
  },
  loadPreData ({ commit, getters, dispatch }, fileName = 'prediction.json') {
    dispatch('setLoading', true)
    dispatch('setLoadingText', '分析预测中')
    dispatch('setPercentage', {'start': 0, 'next': 60})
    axiosSysApi.get('/static/' + fileName).then(function (response) {
      dispatch('setLoadingText', '分析预测中')
      dispatch('setPercentage', {'start': 60, 'next': 100})
      dispatch('delPreData', response.data)
      dispatch('setPrestatus', 20)
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '分析预测异常',
        message: '错误信息:' + e
      })
      dispatch('setLoadingText', '分析预测异常')
      dispatch('setPercentage', {'start': 100, 'next': 100})
      console.log(e)
    })
  },
  setPrestatus ({commit, getters}, data) {
    commit('changePrestatus', data)
  },
  checkData ({commit, getters, dispatch}, data) {
    dispatch('setLoadingText', '数据校验中')
    setTimeout(function () {
      let errorData = []
      let errorDataKey = [{
        oil: '昆明西山广福加油站B',
        type: '0号车用柴油(Ⅴ)',
        date: '9月13日'
      },
      {
        oil: '昆明西山长街加油站',
        type: '92号车用汽油(Ⅴ)',
        date: '9月13日'
      },
      {
        oil: '昆明经开出口加工区站',
        type: '92号车用汽油(Ⅴ)',
        date: '9月13日'
      },
      {
        oil: '昆明宜良阳宗加油站A',
        type: '0号车用柴油(Ⅴ)',
        date: '9月13日'
      }]
      errorDataKey.forEach(function (item) {
        getters.PreSourceData.forEach(function (itemData) {
          if (itemData.oil === item.oil) {
            itemData.data.forEach(function (itemD) {
              if ((itemD[1] === item.type || itemD[1].label === item.type) && itemD[2] === item.date) {
                errorData.push(itemD)
              }
            })
          }
        })
      })
      dispatch('setErrorPreData', errorData)
      dispatch('setLoadingText', '数据校验完成')
      dispatch('setPercentage', {'start': 100, 'next': 100})
    }, 2000)
  },
  loadPreSourceData ({ commit, getters, dispatch }, data) {
    dispatch('setLoading', true)
    dispatch('setLoadingText', '获取数据中')
    dispatch('setPercentage', {'start': 0, 'next': 50})
    axiosSysApi.get('/static/source_data_pre.json').then(function (response) {
      dispatch('delPreSourceData', response.data)
      dispatch('setLoadingText', '获取数据完成')
      dispatch('setPercentage', {'start': 50, 'next': 100})
      dispatch('checkData')
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '获取数据异常',
        message: '错误信息:' + e
      })
      dispatch('setPrestatus', 0)
      dispatch('setLoadingText', '获取数据异常')
      dispatch('setPercentage', {'start': 100, 'next': 100})
      console.log(e)
    })
  },
  loadCarsInfo ({ commit, getters, dispatch }, data) {
    axiosSysApi.get('/static/car_info.json').then(function (response) {
      dispatch('setCarsInfo', response.data['全省车辆信息'])
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '获取数据异常',
        message: '错误信息:' + e
      })
      console.log(e)
    })
  },
  setPreCarData2 ({ commit }, data) {
    let cars = []
    let newData = {}
    data.forEach(function (item) {
      let carId = item[0]
      if (cars.indexOf(carId) === -1) {
        cars.push(carId)
        newData[carId] = []
      }
      newData[carId].push(item)
    })
    let newData2 = []
    cars.forEach(function (item) {
      newData2.push({datas: newData[item], car: item})
    })
    commit('changePreCarData2', newData2)
  },
  loadPreCarData ({ commit, getters, dispatch }, data) {
    dispatch('setLoading', true)
    dispatch('setLoadingText', '匹配车辆中')
    dispatch('setPercentage', {'start': 0, 'next': 100})
    axiosSysApi.get('/static/prediction_car.json').then(function (response) {
      dispatch('setPreCarData', response.data.station)
      dispatch('setPreCarData2', response.data.car)
      dispatch('setLoadingText', '匹配车辆完成')
      dispatch('setPercentage', {'start': 100, 'next': 100})
      dispatch('setPrestatus', 30)
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '匹配车辆异常',
        message: '错误信息:' + e
      })
      dispatch('setLoadingText', '匹配车辆异常')
      dispatch('setPercentage', {'start': 100, 'next': 100})
      console.log(e)
    })
  }
}

let getTime = function (order, num) {
  num = num || 7000
  let heNum = 0
  JSON.parse(order[8]).forEach(function (item) {
    heNum += item
  })
  let hour = (heNum - order[5]) / num
  let day = hour > 0 ? (hour > 23 ? '15' : '14') : '13'
  if (hour < 0) {
    hour = 24 + hour
  }
  let hourNum = parseInt(hour)
  let min = (hour - hourNum) * 60
  let minNum = parseInt(min)
  return '09-' + day + ' ' + ((hourNum % 24) < 10 ? ('0' + (hourNum % 24)) : (hourNum % 24)) + ':' + (minNum < 10 ? ('0' + minNum) : minNum)
}

const mutations = {
  editOnePreSourceData (state, data) {
    state.pre_source_data.forEach(function (item) {
      if (item.oil === data.data[0]) {
        item.data.forEach(function (itemD) {
          if ((itemD[1] === data.data[1] || itemD[1].label === data.data[1]) && itemD[2] === data.data[2]) {
            itemD[data.index] = data.value
          }
        })
      }
    })
  },
  updateCheckData (state) {
    let newData = []
    state.error_pre_data.forEach(function (item) {
      if ((Number(item[3]) + Number(item[4]) - Number(item[5]) - Number(item[6]) + Number(item[8])) !== 0) {
        newData.push(item)
      }
    })
    if (newData.length === 0) {
      state.pre_status = 10
    }
    state.error_pre_data = newData
  },
  changeActiveStation (state, data) {
    state.active_station = data
  },
  changeErrorPreData (state, data) {
    if (data.length === 0) {
      state.pre_status = 10
    }
    state.error_pre_data = data
  },
  changeOilSourceStation (state, data) {
    state.oil_source_station = data
  },
  changeOilSourceStations (state, data) {
    state.oil_source_stations = data
  },
  editOnePre (state, {index, carId}) {
    let order = state.pre_car_data[index]
    let oilName = order[0]
    let oilType = order[3]
    let num = 0
    // 修改车牌号
    order[6] = carId
    // 修改不容纳时间
    state.pre_data.forEach(function (item) {
      if (oilName === item.oil) {
        item.data.forEach(function (item2) {
          if (item2[1] === oilType && item2[3] === '9月14日') {
            num = item2[9]
          }
        })
      }
    })
    order[9] = getTime(order, num)
    let data = []
    state.pre_car_data.forEach(function (item) {
      data.push(item)
    })
    state.pre_car_data = data
  },
  changePrestatus (state, data) {
    state.pre_status = data
  },
  changeOilLocation (state, data) {
    state.oil_location = data
  },
  changeStationLocation (state, data) {
    for (let key in data) {
      state.station_location_list.push(key)
    }
    state.station_location = data
  },
  changeCarsInfo (state, data) {
    state.cars_info = data
  },
  changePreData (state, data) {
    state.pre_data = data
  },
  changeXzData (state, data) {
    state.xz_data = data
  },
  changeDxData (state, data) {
    state.dx_data = data
  },
  changePreSourceData (state, data) {
    state.pre_source_data = data
  },
  changePreCarData (state, data) {
    state.pre_car_data = data
  },
  changePreCarData2 (state, data) {
    state.pre_car_data2 = data
  },
  changePreDayData (state, data) {
    state.pre_day_data = data
  },
  changePreShow3 (state, data) {
    state.pre_show_1 = data
  },
  changeOilStations (state, data) {
    state.oil_stations = data
  },
  changeOilStation (state, data) {
    state.oil_station = data
  },
  changeShowData (state, data) {
    state.pre_show_1 = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/prediction.js